import ClipboardComponent from "@/app/components/ui/Clipboard";
import GeoSearchSelectMenu from "@/app/components/ui/SelectMenus/GeoSearchSelectMenu";
import { useBookingNearestClinicListAPI } from "@/app/hooks/api_hooks/bookings/useBookingNearestClinicListAPI";
import { IClickLogBody, useClickLogAPI } from "@/app/hooks/api_hooks/org/useClickLogAPI";
import useRouteInfo from "@/app/hooks/useRouteInfo";
import { useRouter } from "@/app/hooks/useRouter";
import { useAppSelector } from "@/app_redux/hooks/root_hook";
import { ICustomerProfileState } from "@/app_redux/reducers/slices/auth/customer_profile_slice";
import { ISlotsState } from "@/app_redux/reducers/slices/auth/slots_slice";

import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { MdLocationOn, MdOutlineMyLocation } from "react-icons/md";

export interface INearestClinic {
  open: boolean;
  setOpen: (e: boolean) => void;
  handelSelectClinic: (e: any) => void;
}

const NearestclinicComponent: React.FC<INearestClinic> = ({ open, setOpen, handelSelectClinic }) => {
  const cancelButtonRef = useRef(null);
  const { getRouteKey } = useRouter();
  const routeIdCustomerProfile = getRouteKey("CUSTOMER_PROFILE", "id");
  const { routeState: customerProfileRouteState } = useRouteInfo(routeIdCustomerProfile);
  const { customerId, petId } = customerProfileRouteState.state as ICustomerProfileState;

  const { routeState } = useRouteInfo(getRouteKey("SLOTS", "id"));
  const { isPageReadonly } = routeState.state as ISlotsState;
  const [isClinicSearch, setIsClinicSearch] = useState(false);

  const formHook = useForm<any>({
    mode: "onChange",
    defaultValues: {},
  });

  const { execute: fetchBookingsSlotsAPI, data } = useBookingNearestClinicListAPI();
  const userLogInfo = useAppSelector((state) => state.auth?.user?.email);
  const { execute: logAPI } = useClickLogAPI();

  const handerlClickForNearestClinic = () => {
    setIsClinicSearch(true);
    fetchBookingsSlotsAPI(String(formHook.watch("lat") ?? ""), String(formHook.watch("long") ?? ""));
  };

  const handelClose = () => {
    formHook.setValue("lat", null);
    formHook.setValue("long", null);
    formHook.setValue("locationId", null);
    setOpen(false);
  };

  return (
    <>
      <Transition.Root show={open} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 z-50 overflow-y-auto"
          initialFocus={cancelButtonRef}
          onClose={() => setOpen(true)}
        >
          <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75" />
            </Transition.Child>

            {/* This element is to trick the browser into centering the modal contents. */}
            <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
              &#8203;
            </span>

            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <div
                className={`inline-block  py-3 px-2 align-bottom bg-white rounded-lg text-left  shadow-xl transform transition-all sm:my-8 sm:align-middle sm:w-full sm:max-w-3xl`}
              >
                <div className={`${data?.length > 6 && " h-[600px] overflow-y-auto"}`}>
                  <div className="flex justify-between items-center mx-3 pt-3 border-b-2 border-gray-50">
                    <h3 className="text-base font-semibold text-gray-800 ">🔍 Search Nearest Clinic</h3>

                    <div
                      className="cursor-pointer"
                      onClick={() => {
                        handelClose();
                      }}
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
                        <path
                          d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
                          fill="black"
                        />
                      </svg>
                    </div>
                  </div>

                  <div className="w-full p-4 space-y-6">
                    {/* Search Box */}
                    <div className="flex justify-between items-center">
                      <GeoSearchSelectMenu
                        autoComplete="off"
                        autoCorrect="false"
                        withClearAction
                        clearSearch={formHook?.getValues("city") !== ""}
                        showDropdownWhenNoData
                        label=""
                        labelInfo="You can search by nearest location and all the clinics will be fetched."
                        onSelectItem={(item) => {
                          formHook.setValue("locationId", item.id);
                          formHook.setValue("lat", item.state.lat);
                          formHook.setValue("long", item.state.long);
                          handerlClickForNearestClinic();
                          const logBody: IClickLogBody = {
                            event_type: "SEARCH_NEAREST_CLINIC",
                            client_id: customerId ? customerId : null,
                            pet_id: petId ? petId : null,
                            location_details: {
                              lat: item.state.lat,
                              long: item.state.long,
                              address: item?.title,
                            },
                            vms_user_id: userLogInfo,
                            scr_id: isPageReadonly ? "CHECK_SLOT" : "BOOKING_PAGE",
                            timestamp: Date.now(),
                          };
                          item?.title && logAPI(logBody);
                        }}
                        listBoxClassName=""
                        containerClassName="w-full"
                        errorMessages={[]}
                        fieldError={formHook.formState.errors.lat}
                        register={formHook.register("locationId", {
                          required: false,
                        })}
                        onClear={() => {
                          formHook.setValue("locationId", null);
                          formHook.setValue("lat", null);
                          formHook.setValue("long", null);
                          handerlClickForNearestClinic();
                        }}
                        showTypedErrors={false}
                        placeholder="Search Nearby Clinic"
                      />
                    </div>
                    {/* Clinic List */}

                    {data?.length > 0 ? (
                      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                        {data?.map((clinic, index) => (
                          <div
                            key={index}
                            className="border cursor-pointer rounded-2xl shadow-sm hover:shadow-lg transition bg-white overflow-hidden flex flex-col"
                          >
                            <div
                              className="relative w-full h-24"
                              onClick={() => {
                                const logBody: IClickLogBody = {
                                  event_type: "SELECT_CLINIC_FROM_SEARCH",
                                  client_id: customerId ? customerId : null,
                                  pet_id: petId ? petId : null,
                                  clinic_id: clinic?.clinic_id,
                                  clinic_name: clinic?.clinic_name,
                                  location_details: {
                                    lat: clinic?.latitude,
                                    long: clinic?.longitude,
                                    address: clinic?.address_l1,
                                  },
                                  vms_user_id: userLogInfo,
                                  scr_id: "BOOKING_PAGE",
                                  timestamp: Date.now(),
                                };
                                logAPI(logBody);
                                handelClose();
                                handelSelectClinic(clinic);
                              }}
                            >
                              <img
                                src={
                                  clinic?.clinic_image ||
                                  "https://vetic-img.s3.ap-south-1.amazonaws.com/website/Website-Astro/home_page_image/pet_love_vetic/Expert+Vets+(6).webp"
                                }
                                alt={clinic.clinic_name}
                                className="w-full h-24 object-cover rounded"
                              />
                              {clinic?.full_day_open && (
                                <span className="absolute top-0 right-0 bg-red-600 text-white text-sm font-semibold px-8 py-1 rounded-tr-lg shadow-md">
                                  24x7
                                </span>
                              )}
                            </div>

                            <div className="flex flex-col flex-1 p-3">
                              <h3 className="font-semibold text-xs mb-1">{clinic.clinic_name}</h3>
                              <p className="text-xs text-gray-700 flex-1">{clinic.address_l1}</p>
                              <div className="flex items-center justify-between pt-3 border-t mt-3">
                                <div className="flex items-center gap-2 text-sm">
                                  <MdLocationOn className="text-red-500 w-4 h-4" />
                                  {clinic.distance && (
                                    <span className="inline-flex items-center gap-1 text-sm font-medium text-green-700 bg-green-50 border border-green-200 px-2 py-0.5 rounded-md">
                                      <MdOutlineMyLocation className="w-3 h-3" />
                                      {clinic.distance} km
                                    </span>
                                  )}
                                </div>

                                {/* Copy Location */}

                                <ClipboardComponent
                                  className="ml-2 text-blue-500 hover:text-blue-700"
                                  tooltipText={`Copy clinic address : ${clinic.clinic_name}`}
                                  text={`Clinic: ${clinic.clinic_name}\nAddress: ${clinic.address_l1}\nLocation: ${clinic.location_url}`}
                                  copyId={`Clinic: ${clinic.clinic_name}\nAddress: ${clinic.address_l1}\nLocation: ${clinic.location_url}`}
                                  onCopyText={() => {
                                    const logBody: IClickLogBody = {
                                      event_type: "COPY_CLINIC_ADDRESS",
                                      client_id: customerId ? customerId : null,
                                      pet_id: petId ? petId : null,
                                      location_details: {
                                        lat: clinic?.latitude,
                                        long: clinic?.longitude,
                                        address: clinic?.address_l1,
                                      },
                                      vms_user_id: userLogInfo,
                                      scr_id: isPageReadonly ? "CHECK_SLOT" : "BOOKING_PAGE",
                                      timestamp: Date.now(),
                                    };
                                    logAPI(logBody);
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      isClinicSearch && (
                        <p className="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-green-600 bg-green-50 rounded-lg">
                          <span>🔍</span> No Clinic found, please search
                        </p>
                      )
                    )}
                  </div>
                </div>
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition.Root>
    </>
  );
};

export default NearestclinicComponent;
